import {ContextObject} from '../context-object'
import {DataObjectId} from 'yougile-model'
import {Context} from '../context'

export class System extends ContextObject {
  public static override registered: Map<DataObjectId, Map<string, System>> =
    new Map()
  private timeouts: number[] = []
  private intervals: number[] = []

  constructor(context: Context, global: any) {
    super(context, global)

    this.global.setInterval = (...args: any[]): number => {
      const id = (window.setInterval as any)(...args)
      this.timeouts.push(id)
      return id
    }

    this.global.setTimeout = (...args: any[]): number => {
      const id = (window.setTimeout as any)(...args)
      this.intervals.push(id)
      return id
    }
  }

  public override beforeUnload(): void {
    // api:exclude
    this.intervals.forEach((id: number) => {
      clearInterval(id)
    })
    this.intervals = []

    this.timeouts.forEach((id: number) => {
      clearInterval(id)
    })
    this.timeouts = []
  }
}
